import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ProfileComponent } from './profile/profile.component';
import { SignupComponent } from './signup/signup.component';
import { EmailComponent } from './email/email.component';
import { AngularFireAuth } from 'angularfire2/auth';
import { Router } from '@angular/router';
import { DocumentosComponent } from './documentos/documentos.component';
import { UserProvider } from './user.service';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'email-login', component: EmailComponent },
  { path: 'documentos', component: DocumentosComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'profile', component: ProfileComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

  nivel: string;

  constructor(
    afAuth: AngularFireAuth,
    private router: Router,
    public userservice: UserProvider
  ) {
    
    const authObserver = afAuth.authState.subscribe(user => {
      if (user){
        console.log(user.uid);
        this.userservice.getuserdetails()
          .then((res : any) => {
            if(res.nivel == 1){
              this.router.navigateByUrl('/profile');
              authObserver.unsubscribe();
            }else{
              this.router.navigateByUrl('/documentos');
              authObserver.unsubscribe();
            }
          }).catch((error : any) => {

          })

      } else {
        this.router.navigateByUrl('/email-login');
        authObserver.unsubscribe();
      }
    })
  }
}


// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts